export const parseDataChartYearToDate = (data, isVolume = true) => {
  const dataChart = [
    { division: "JAN", name: "january" },
    { division: "FEB", name: "february" },
    { division: "MAR", name: "march" },
    { division: "APR", name: "april" },
    { division: "MAY", name: "may" },
    { division: "JUN", name: "june" },
    { division: "JUL", name: "july" },
    { division: "AUG", name: "august" },
    { division: "SEP", name: "september" },
    { division: "OCT", name: "october" },
    { division: "NOV", name: "november" },
    { division: "DEC", name: "december" },
  ];

  const divisions = ["sales", "cs", "office"];

  divisions.forEach((division) => {
    dataChart.forEach((month) => {
      if (isVolume) {
        month[division] = data[division]?.[month.name] ?? 0;
      } else {
        const total =
          (data.sales?.[month.name] ?? 0) +
          (data.cs?.[month.name] ?? 0) +
          (data.office?.[month.name] ?? 0);

        month[division] =
          total <= 0 ? 0 : calculatePercentage(data[division]?.[month.name] ,total);
      }
    });
  });

  return dataChart;
};


export const parseDataChartLast3Year = (data, isVolume = true, year) => {
  // Base structure for Recharts
  const dataChart = [
    { division: `Q1 ${year - 2}`, name: "year2Quartal1" },
    { division: `Q2 ${year - 2}`, name: "year2Quartal2" },
    { division: `Q3 ${year - 2}`, name: "year2Quartal3" },
    { division: `Q4 ${year - 2}`, name: "year2Quartal4" },
    { division: `Q1 ${year - 1}`, name: "year1Quartal1" },
    { division: `Q2 ${year - 1}`, name: "year1Quartal2" },
    { division: `Q3 ${year - 1}`, name: "year1Quartal3" },
    { division: `Q4 ${year - 1}`, name: "year1Quartal4" },
    { division: `Q1 ${year}`, name: "yearQuartal1" },
    { division: `Q2 ${year}`, name: "yearQuartal2" },
    { division: `Q3 ${year}`, name: "yearQuartal3" },
    { division: `Q4 ${year}`, name: "yearQuartal4" },
  ];

  // Transform data
  const result = dataChart.map((q) => {
    const newItem = { division: q.division };
    data.forEach((role) => {
      const value = role.dataQuartal[q.name] ?? 0;
      if (isVolume) {
        newItem[role.role] = value;
      } else {
        const total = data.reduce(
          (sum, r) => sum + (r.dataQuartal[q.name] ?? 0),
          0
        );
        newItem[role.role] = total > 0 ? calculatePercentage(value, total) : 0;
      }
    });
    return newItem;
  });

  return result;
};


export const calculatePercentage = (value, total) => {
  if (total === 0) return 0;
  return Number(((value / total) * 100).toFixed(2));
};


function countTotalMonth(data, i) {
  let total = 0;
  data.forEach((d) => {
    total += d[i];
  });
  return total;
}

export const parseDataKey = (data) => {
  let dataKey = [];
  const { totalCS, totalOffice, totalSales, ...rest } = data;
  const arr = Object.keys(rest);
  arr.map((i, idx) => {
    dataKey[idx] = {
      key: i,
      color: generateReadableColor(idx, data.length),
    };
  });
  return dataKey;
};

export const parseDataKeyL3Y = (data) => {
  let dataKey = [];
  data.map((i, idx) => {
    dataKey[idx] = {
      key: i.role,
      color: generateReadableColor(idx, data.length),
    };
  });
  return dataKey;
};

function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) =>
    Math.round(255 * (l - a * Math.max(Math.min(k(n) - 3, 9 - k(n), 1), -1)))
      .toString(16)
      .padStart(2, "0");
  return `#${f(0)}${f(8)}${f(4)}`;
}

function generateReadableColor(index = 0, total = 20) {
  const hue = (index * (360 / total)) % 360; // evenly spaced hues
  const saturation = 70; // keep color vivid
  const lightness = 65; // avoid dark tones

  return hslToHex(hue, saturation, lightness);
}
